import { FC } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { Text } from '@/shared/uikit/Text';
import { Title } from '@/shared/uikit/Title';

export const UnsupportedFormat: FC = () => {
  return (
    <Container>
      <Icon name="empty" size="s64" style={{ color: COLORS.systemDark100 }} />
      <Title style={{ marginTop: 12, color: COLORS.systemLight100 }} size={22} bold>
        Undisplayable format
      </Title>
      <Text style={{ marginTop: 4, color: COLORS.systemLight100 }}>
        Cant display this file format
      </Text>
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  color: ${COLORS.systemLight100};
  justify-items: center;

  position: absolute;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
`;
